const state = {
    recurring_id: null,
    recurring_template_id: null,
    recurring_settings_id: null,

    recurringAddDialog: false,

    // plans
    recurringTemplateAddDialog: false,

    recurringTemplateDetailDialog: false,
    recurringSettingsCustomDialog: false,
    recurringSettingsMetaDialog: false,
    recurringSettingsNotificationEmailDialog: false,
    recurringSettingsDialog: false,

    invoice_id: null,
    invoice_template_id: null,
    invoice_settings_id: null,
    invoiceMetaDialog: false,
    invoiceAddDialog: false,
    invoiceShowNotes: false,

    itemTaxDialog: false,
    itemDiscountDialog: false,
    itemFeeDialog: false,
    taxDialog: false,
    discountDialog: false,
    feeDialog: false,
    addItemDialog: false,

    order_id: null,
    schedule_id: null,

    header: true,
    titlebar: true,

    labels: {
        totalAmount: "Total Amount",
    }

};

const getters = {};

const mutations = {};

const actions = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
